<template>
  <div  class="video-background" @click="showContent = true">

    <!-- ✅ 배경 동영상 -->

    
    <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
        Loading...
    </div>

    
    <!-- <v-app-bar app flat color="white" elevation="2">
      <v-toolbar-title class="text-primary font-weight-bold">SEOHAN SYSTEM</v-toolbar-title>
      <v-btn text to="/">Home</v-btn>
      <v-btn text to="/dailyDemand">Material</v-btn>
      <v-spacer></v-spacer>
    </v-app-bar> -->

    <sidenav
      v-if="showSidenav && !isLoginPage"
      ref="sidenavRef"
      :custom_class="color"
      class="fixed-start custom-font top-navbar-fixed"
      :username="username"
      :is-mini="isSidenavMini"
    />

    <main class="main-content position-relative h-100 ps overflow-x-hidden" style="padding-top: 6vh;" 
      :class="`${isLoginPage ? 'login-page' : ''} ${isDisplay ? '' : 'isDisplay'}`">
      <header class="custom-navbar" :class="{ 'hidden-navbar': !showHeader }"    :style="{ marginLeft: isSidenavMini ? '96px' : '250px' }"
       v-if="!isLoginPage">
        <div class="navbar-left">
          <!-- 햄버거 버튼 -->
          <button class="hamburger-btn" @click="toggleNavbarMenu">
            <i class="fas fa-bars"></i>
          </button>
          <a href="/" class="navbar-link">
                <i class="fas fa-home mr-2 ml-5"></i> Home
              </a>
              <a href="/materialMain" class="navbar-link">
                <i class="fas  mr-2"></i> Material
              </a>
        </div>

        <div class="navbar-right">
          <div class="nav-user-container" @click="toggleUserMenu">
            <img src="@/assets/img/sample_user2.png" class="avatar2" alt="User" />
            <span class="username">{{ userName }}</span>
            <i class="material-icons dropdown-icon">arrow_drop_down</i>

            <transition name="dropdown">
              <div v-if="userMenuOpen" class="dropdown-menu2 user-dropdown" :style="{ marginLeft: isSidenavMini ? '15vh' : '0vh' }">
                <div class="dropdown-item" style = "padding-left: 1px;" @click.stop="changePassword">
                  <i class="fas fa-user-lock mr-2"></i> Change Password
                </div>
                <div class="dropdown-item" style="padding-left: 1px;" @click.stop="logout">
                  <i class="fas fa-sign-out-alt mr-2"></i> Logout
                </div>
                
              </div>
              
            </transition>
          </div>
        </div>
      </header>

      <navbar v-if="showNavbar" :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
        :color="isAbsolute ? 'text-white opacity-8' : ''" :min-nav="navbarMinimize" />
      <router-view :username="username"></router-view>

      <app-footer v-show="showFooter && !isLoginPage" />
    </main>
  </div>
  <div v-if="showChangePasswordModal" class="modal-overlay">
  <div class="modal-content">
    <div class="modal-header">
      <span class="modal-title">Reset Password</span>
      <span class="modal-close" @click="showChangePasswordModal = false">&times;</span>
    </div>
    <div class="modal-body">
      <!-- <div class="form-outline mb-7">
        <input type="text" class="form-control" v-model="changePasswordForm.username" placeholder="Username" />
      </div> -->
      <div class="form-outline mb-7">
        <input type="password" class="form-control" v-model="changePasswordForm.newPassword" placeholder="New Password" />
      </div>
      <div class="form-outline mb-10">
        <input type="password" class="form-control" v-model="changePasswordForm.confirmPassword" placeholder="Confirm New Password" />
      </div>
      <button class="btn btn-primary btn-block" @click="submitChangePassword">Submit</button>
    </div>
  </div>
</div>
</template>
<script>
import router from './router/index';
import Sidenav from './components/Sidenav';
import Navbar from "@/components/Navbars/Navbar.vue";
import AppFooter from "@/components/Footer.vue";

import { mapState } from "vuex";
// import axios from 'axios';

import axios from 'axios';

axios.defaults.withCredentials = true;

// ✅ 요청 보낼 때 accessToken 자동 삽입
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  async error => {
    //console.log('axios interceptor triggered'); // 이거 넣어봐

    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const res = await axios.get('/api/refresh-token'); // refresh 토큰 요청
        const newAccessToken = res.data.accessToken;
        //console.log('[❌] refreshToken 요청', res.data);

        if (newAccessToken) {
          localStorage.setItem('accessToken', newAccessToken);
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axios(originalRequest); // 재요청
        }
      } catch (err) {
        console.error('[❌] refreshToken 재발급 실패');
        //console.log('[❌] refreshToken 재발급 실패');

        localStorage.removeItem('accessToken');
        router.push('/login');

        // window.location.href = '/login'; // 로그인 페이지로 이동
      }
    }

    return Promise.reject(error);
  }
);


// import axios from 'axios';
export default {
  name: 'App',
  
  components: {
    Sidenav,
    AppFooter,
    Navbar,
  },


  mounted() {
    this.loading = true;

    if (!this.isLoginPage) {
      this.$store.dispatch('checkSessionStatus');
    }

    this.loading = false;
    const sidenav = this.$refs.sidenavRef?.$el;
    if (sidenav) {
      sidenav.addEventListener('mouseenter', this.expandSidebar);
      sidenav.addEventListener('mouseleave', this.collapseSidebar);
    }
    // ✅ 실제 스크롤 되는 main-content를 선택해서 이벤트 추가
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener('click', this.handleClickOutside); // 👈 바깥 클릭 감지

  },

  beforeUnmount() {
    this.isSidenavMini = false;      // ⭐️ 항상 확장 상태로 시작
    this.isManualToggle = false;     // ⭐️ 자동 확장/축소 모드로 초기화
    const sidenav = this.$refs.sidenavRef?.$el;
    if (sidenav) {
      sidenav.removeEventListener('mouseenter', this.expandSidebar);
      sidenav.removeEventListener('mouseleave', this.collapseSidebar);
    }
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside); // 👈 제거
    
  },

  computed: {
    ...mapState([
      "showSidenav",
      "showFooter",
      "isAbsolute",
      "isNavFixed",
      "username",
      "userName",
      
    ]),
    ...mapState({
      username: (state) => state.username, // Vuex 상태에서 username 가져오기
    }),
    isLoginPage() {
      return this.$route.meta.isLoginPage;
    },


  },
  beforeMount() {
    this.loading = true;
    this.getUsername();
    this.getUsername();
    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
    this.loading = false;
    
  },
  router,
  data() {
    return {
      isDisplay: true,
      loading: false,
      showContent: false,
      showHeader: true,
      lastScrollTop: 0,
      scrollTimer: null,
      isNavbarOpen: false, // ✅ 햄버거 메뉴 상태
      userMenuOpen: false, // ✅ 유저 메뉴 드롭다운 상태
      isSidenavMini: false,  // ← 이게 핵심!
      isManualToggle: false, // ✅ 추가
      showChangePasswordModal: false,
      changePasswordForm: {
        username: '',
        newPassword: '',
        confirmPassword: ''
      }
    };
  },
  methods: {
    changePassword() {
      this.showChangePasswordModal = true;
    },
    async submitChangePassword() {
      const {  newPassword, confirmPassword } = this.changePasswordForm;

      if (!newPassword || !confirmPassword) {
        alert("Enter all fields.");
        return;
      }

      if (newPassword !== confirmPassword) {
        alert("Passwords do not match.");
        return;
      }
      try {
        const response = await fetch('/api/resetPassword', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: this.username, newPassword })
        });

        const data = await response.json();
        if (data.success) {
          alert("Password successfully reset.");
          this.showChangePasswordModal = false;
          this.changePasswordForm = { username: '', newPassword: '', confirmPassword: '' };
        } else {
          alert(data.message || "Failed to reset password.");
        }
      } catch (err) {
        console.error('Password Reset Error:', err);
        alert("An error occurred.");
      }
    },
    expandSidebar() {
      if (!this.isManualToggle) {
        this.isSidenavMini = false;
      }
    },
    collapseSidebar() {
      if (!this.isManualToggle) {
        this.isSidenavMini = true;

      }
    },
    async logout() {
      localStorage.removeItem('accessToken');

        // 로그아웃 로직
        await fetch('/api/logout', {
            method: 'POST',
            credentials: 'include', // 쿠키를 포함하기 위해 필요
        });
        // 로그아웃 후 로그인 페이지로 리다이렉션
        this.$router.push('/login');
    },

    toggleNavbarMenu() {
      this.isManualToggle = !this.isManualToggle;
      this.isSidenavMini = !this.isSidenavMini;
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");

      return routeArr[1];
    },
    handleScroll() {
      const currentScroll = window.scrollY;

      if (currentScroll > this.lastScrollTop) {
        this.showHeader = false; // 아래로 스크롤 중 → 숨김
      } else {
        this.showHeader = true;  // 위로 스크롤 중 → 보임
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    },

    // 메서드 업데이트
    // getUsername() {
    //   // 비동기 로직은 바로 반환되지 않으므로, 결과를 state에 저장해야 합니다.

    //   if (!this.$route.meta.isLoginPage) {
    //       .then((response) => {
    //         //console.log("hello");
    //         this.username = response.data.username; // 서버로부터 받은 username으로 업데이트
    //       })
    //       .catch((error) => {
    //         console.error('Error fetching username:', error);
    //       });
    //   }
    // },

    async getUsername() {
      this.loading = true;
      try {
        await this.$store.dispatch('checkSessionStatus');
        // `checkSessionStatus` 액션은 Vuex 스토어의 `username` 상태를 업데이트합니다.
        // 여기서는 별도의 처리가 필요하지 않습니다.
        
      } catch (error) {
        console.error('Error fetching username:', error);
      }
      this.loading = false;
    },

    async getUserName() {
      this.loading = true;
      try {
        await this.$store.dispatch('checkSessionStatus');
        // `checkSessionStatus` 액션은 Vuex 스토어의 `username` 상태를 업데이트합니다.
        // 여기서는 별도의 처리가 필요하지 않습니다.
        
      } catch (error) {
        console.error('Error fetching username:', error);
      }
      this.loading = false;
    },
    updateUser(username) {
      this.$store.commit('setUsername', username);

    },
    updateUserName(userName) {
      this.$store.commit('setUserName', userName);
    }
  }

};
</script>

<style scoped>

.top-navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999; /* ✅ 다른 요소보다 위에 오게 */
}

.background-container {
  background-image: url("../src/assets/img/nature.jpg"); /* 저장된 이미지 경로 */
  background-size: cover; /* 화면에 맞게 조정 */
  background-position: center; /* 가운데 정렬 */
  background-repeat: no-repeat; /* 반복 없음 */
  min-height: 100vh; /* 최소 화면 높이 */
  width: 100%;
}
body main , body .sidenav, body .sidenav .sidenav-list, body main div{
  font-family: 'Noto Sans KR', "Noto Sans", sans-serif !important;
}
h3 {
  font-family: 'Noto Sans KR', "Noto Sans", sans-serif !important;
}
#app {
  font-family: 'Noto Sans KR', "Noto Sans", sans-serif !important;
}
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}


.maximize-content {
    margin-left: 0 !important;
    background: black;
    min-height: 1300px !important;
    padding-top: 60px;
}


.sidenav {
  z-index: 1000 !important;
}


.video-background {
  position: relative;
  width: 100%;
  height: 100vh; /* 전체 화면 */
  overflow: hidden;

}

/* ✅ 배경 비디오 스타일 */
.background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover; /* 화면 가득 채우기 */
  z-index: -2; /* 내용보다 뒤에 배치 */
}

/* ✅ 콘텐츠 스타일 */
.content {
  position: relative;
  z-index: -2; /* 비디오 위에 내용 표시 */
  color: white; /* 텍스트 가독성을 위해 흰색 */
  text-align: center;
  padding-top: 50px;
}

.text-container {
    height: 80vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}

/* 텍스트 스타일 */
.welcome-text {
    font-size: 3rem; /* 글자 크기 */
    font-weight: bold;
    color: white; /* 텍스트 색상 */
    text-align: center; /* 텍스트 중앙 정렬 */
    animation: slideIn 7s ease-out; /* 애니메이션 적용 */
    z-index: -1;
}
@keyframes slideIn {
    from {
        opacity: 0; 
        transform: translateX(-50px); /* 왼쪽에서 시작 */
    }
    to {
        opacity: 1; 
        transform: translateX(0); /* 원래 위치로 */
    }
}
.logo-container {
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 10;
}

.logo-image {
  width: 45px;
  height: auto;
  padding-right: 10px;
}

.custom-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 63px;
  background-color: white;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  z-index: 5;
  font-family: 'Noto Sans KR', sans-serif;
  transition: margin-left 0.3s ease !important;

}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 20px;

}

.navbar-title {
  font-weight: bold;
  color: #1976d2; /* Vuetify primary 색 비슷하게 */
}

.navbar-link {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  padding-right: 10px;
}

.navbar-link:hover {
  text-decoration: underline;
}

.navbar-right {
  font-size: 14px;
  color: #333;
}
.main-content {
  height: auto;
  min-height: 100vh;
  overflow-y: auto;
}
.custom-navbar {
  transition: top 0.3s ease-in-out;
}
.hidden-navbar {
  top: -80px; /* 바깥으로 숨김 */
}

.hamburger-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  padding: 5px;
  color: #333;
}

.navbar-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 20px;
}

.dropdown-menu {
  position: absolute;
  top: 60px; /* navbar 아래에 나오게 */
  left: 0vh; /* 햄버거 버튼과 맞춰 정렬 */
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  padding: 10px;
  border-radius: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: 150px;
}

.dropdown-menu2 {
  position: absolute;
  top: 6.6vh; /* navbar 아래에 나오게 */
  left: 157vh; /* 햄버거 버튼과 맞춰 정렬 */
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  padding: 10px;
  border-radius: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: 160px;
}

/* 드롭다운 애니메이션 */
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s ease;
}
.dropdown-enter-from, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.dropdown-enter-to, .dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.avatar2 {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
  }
  .nav-user-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    }

    .dropdown-icon {
    position: relative;
    top: 1px; /* 👈 여기로 위치를 조정하세요 */
    font-size: 20px;
    color: #555;
    }

    @font-face {
    font-family: 'HyundaiSans2';
    src: url('assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */

</style>